import { createAsyncThunk } from '@reduxjs/toolkit';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import {
	getGuidesInfoByCategory as getGuidesInfoByCategoryApi,
	getGuidesInfoByType as getGuidesInfoByTypeApi,
	getGuidesInfoByStatus as getGuidesInfoByStatusApi,
	getGuidesInfoByEstablishmenteType as getGuidesInfoByEstablishmenteTypeApi,
	getGuidesInfoCompareType as getGuidesInfoCompareTypeApi,
	getGuidesInfoCompareStatus as getGuidesInfoCompareStatusApi,
	getGuidesInfoCompareManagement as getGuidesInfoCompareManagementApi,
	getGuidesInfoByFinalDestination as getGuidesInfoByFinalDestinationApi,

	getPointEstablishmentResidue as getPointEstablishmentResidueApi,

	getCategoryByYear as getCategoryByYearApi,
	getResidueManagement as getResidueManagementApi
} from '../../helpers/residue_dashboard/backend_helper';

export const getGuidesInfoByCategory = createAsyncThunk('residue_dashboard/getGuidesInfoByCategory', async id => {
	try {
		const response = getGuidesInfoByCategoryApi(id);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getGuidesInfoByType = createAsyncThunk('residue_dashboard/getGuidesInfoByType', async id => {
	try {
		const response = getGuidesInfoByTypeApi(id);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getGuidesInfoByStatus = createAsyncThunk('residue_dashboard/getGuidesInfoByStatus', async id => {
	try {
		const response = getGuidesInfoByStatusApi(id);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getGuidesInfoByEstablishmenteType = createAsyncThunk('residue_dashboard/getGuidesInfoByEstablishmenteType', async () => {
	try {
		const response = getGuidesInfoByEstablishmenteTypeApi();
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getCategoryByYear = createAsyncThunk('residue_dashboard/getCategoryByYear', async () => {
	try {
		const response = getCategoryByYearApi();
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getResidueManagement = createAsyncThunk('residue_dashboard/getResidueManagement', async () => {
	try {
		const response = getResidueManagementApi();
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getGuidesInfoByFinalDestination = createAsyncThunk('residue_dashboard/getGuidesInfoByFinalDestination', async () => {
	try {
		const response = getGuidesInfoByFinalDestinationApi();
		return response;
	} catch (error) {
		throw new Error(error);
	}
});



export const getGuidesInfoCompareType = createAsyncThunk('residue_dashboard/getGuidesInfoCompareType',async id => {
	try {
		const response = getGuidesInfoCompareTypeApi(id);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getGuidesInfoCompareStatus = createAsyncThunk('residue_dashboard/getGuidesInfoCompareStatus',async id => {
	try {
		const response = getGuidesInfoCompareStatusApi(id);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});


export const getGuidesInfoCompareManagement = createAsyncThunk('residue_dashboard/getGuidesInfoCompareManagement',async id => {
	try {
		const response = getGuidesInfoCompareManagementApi(id);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getPointEstablishmentResidue = createAsyncThunk('residue_dashboard/getPointEstablishmentResidue',async id => {
	try {
		const response = getPointEstablishmentResidueApi(id);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

